import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { ILSAppRegistry } from '../../index';

type RootState = ReturnType<typeof ILSAppRegistry.store.getState>;
type AppDispatch = typeof ILSAppRegistry.store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
